export default __webpack_public_path__ + "static/media/subscriptionPlanPdf.37dec495.pdf";